// @ts-ignore
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, AfterViewInit, Inject, HostListener } from '@angular/core';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { DomSanitizer } from '@angular/platform-browser';
// @ts-ignore
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { format } from 'date-fns';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { CertificateType, CertificateTypeID, Common } from 'src/app/core/constants/common';
import { DocumentService } from 'src/app/core/services/document.service';
import { CanvasService } from 'src/app/core/services/canvas.service';
import { CanvasComponent } from 'src/app/shared/components/canvas/canvas.component';
import { ApiService } from 'src/app/core/services/api.service';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { NotificationService } from 'src/app/core/services/notification.service';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { BehaviorSubject, concat, from, Observable, of, Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import * as _ from 'lodash';
import { NotifyWarningComponent } from 'src/app/shared/components/notify-warning/notify-warning.component';
import * as uuid from 'uuid';
import { EnvService } from 'src/app/core/services/env.service';
import { SigningConfirmDialogComponent } from '../../signing-confirm-dialog/signing-confirm-dialog.component';
import { UsbTokenService } from 'src/app/core/services/usb-token.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import {EnumContractStatus, EnumSignMethod} from 'src/app/core/constants/contract';
import { EkycCameraComponent } from '../../ekyc/ekyc-camera/ekyc-camera.component';
import { SignPositionTypes } from 'src/app/core/constants/signposition-types';
import { AddDigitalCertificateComponent } from '../../../digital-certificate/add-digital-certificate/add-digital-certificate.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';

import FileUtils from '../../../../../../../core/services/file-utils';
import { SaveSessionCloudCaDialogComponent } from '../../sign-flow-document-v2/save-session-cloud-ca-dialog/save-session-cloud-ca-dialog.component';

declare var $: any;

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginSign(comp): any;

declare function getSessionId(): any;


declare function initPluginCertificateNormal(comp: any, contracts: any): any;

declare function anonymousSignHash(comp, hashBase64, sessionId, serialNumber): any;

declare function signHashNormal(comp, hashBase64, sessionId, serialNumber): any;

declare function normalSignHash(comp, hashBase64, sessionId, serialNumber): any;

declare function checkPlugin(comp): any;

interface SelectedCertInterface {
  serialNumber: string,
  phoneNumber: any,
  typeCertificate: any,
  id: any,
  idDetail: any,
  imageUrl: any,
  issuedTo: string,
  taxCode: string,

  [key: string]: any
}

@Component({
  selector: 'app-select-sign-method',
  templateUrl: './select-sign-method.component.html',
  styleUrls: ['./select-sign-method.component.scss']
})
export class SelectSignMethodComponent implements OnInit, AfterViewInit, OnDestroy {
  countAllApiBeforeCertificateDefault = 0;
  sertificateDefaultOnj: any;
  private isGotoSignpage = false;
  isCertificateDefault = false;
  public listPdfSrc = {};
  public isCancelSign = false;
  contractSignEntityList = []
  signTransactionId: any;
  signImages = [];
  saveImageData = [];
  subscriptions: Subscription = new Subscription();
  isHsmPermission = false
  showPopupSaveTrans: boolean = false;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private digitalCertificateService: DigitalCertificateService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private activeRoute: ActivatedRoute,
    private signDocumentService: SignDocumentService,
    private breadcrumbsService: BreadcrumbsService,
    private documentService: DocumentService,
    private canvasService: CanvasService,
    private apiService: ApiService,
    public notificationService: NotificationService,
    private usbTokenService: UsbTokenService,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private enterpriseService: EnterpriseService,
    private env: EnvService,
    public selectMethodDialogRef: MatDialogRef<SelectSignMethodComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
    this.userType = Number(localStorage.getItem('userType'));
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.enterpriseName = localStorage.getItem('fullName');
    this.permissions = localStorage.getItem('permissions').match(/\d+/g).map(Number);
    pdfDefaultOptions.renderInteractiveForms = false;
    this.language = localStorage.getItem('__language') || 'vi';
    this.subscribeHash = new BehaviorSubject<string>('');
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract';
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    // this.getButtonsMobile();
    this.subscriptions.add(
      this.signDocumentService.openSigningDialog.asObservable().subscribe(rs => {
        this.openSigningDialog = rs
      })
    );

    selectMethodDialogRef.disableClose = true;
    selectMethodDialogRef.backdropClick().subscribe((_) => {
      this.onNoClick();
    });
  }

  public language: string;
  public isShowSidebarButton = true;
  private serialNumber: string;
  private sessionId: string;
  private isClickSignBuuton = false;
  private errorStatus: string;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public subcribeViewLandscape: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  public signPosition: any[];
  public isAllowSelectSignPosition = true;

  subscribeHash: BehaviorSubject<string>;
  private permissions = [];
  private linkDownSignPlugin(os?: string) {
    let OSName = os;
    if (typeof (os) === 'undefined') {
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";
    }
    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };
  isCheckAccessToContract = true;
  private dialogRef: any;

  private leftPosition: number;
  page = 1;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: string;
  public document: any;
  private customerName: '';
  selectedImage: File;
  selectedImageUrl: string | ArrayBuffer;
  isDisableNextButton = true;
  disableSignBtn = true;
  private indexSelect: number = 0;
  openSigningDialog = false;

  private sign: any;
  private contractId: string;
  private certificate = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined
  };
  public SIGN_HSM = 4;
  private success: boolean;
  public enterpriseName: string;
  private imageData = [];
  enumSignMethod = EnumSignMethod;
  public isViewLandscape: boolean = false;

  public imageUrlPreview: any;

  private pageIndex = 0;
  private isSelectPosition: any = true;
  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  private signPage: any;

  private isSelectDrawImage = false;
  private fileUpload: File;
  public loading: boolean;
  public avatarUrl: string;
  signingInteval: any
  current = 0;

  index = 'First-content';
  imageCertificates = [];
  certificates = [];

  isConfiguredSign: boolean = false

  typeCertificate: number;
  selectedCert: SelectedCertInterface = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    taxCode: '',
  }
  private disableBtnDeleteCanvas: boolean;
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    SIGN_NO_CERT: 6,
    SIGN_EKYC: 7,
    SIGN_EKYC_ADVANCED: 8,
  };
  columnsToDisplaySimCA: string[] = [];

  columnDefinitionsSimCA = [
    { def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true },
    { def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'taxCode', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true },
    { def: 'phoneNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true }
  ];


  columnsToDisplayOther: string[] = [];
  columnDefinitionsOther = [
    { def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true },
    { def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'taxCode', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true }
  ];

  columnsToDisplayCloudCa: string[] = [];
  columnDefinitionsCloudCa = [
    { def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true },
    { def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'taxCode', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'cloudCaUsername', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true },
    { def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true },
    { def: 'hasTransSaved', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true }
  ];

  private userType: number;
  private enterpriseId: string;
  private selectedIndex: number;
  pdfSrc: any;
  zoomLevel = 100;
  currentDate = new Date();
  @ViewChild('myCanvas', { static: false }) canvas: ElementRef;
  @ViewChild('navigation', { static: false }) navigation: ElementRef;
  @ViewChild('btnView', { static: false }) private btnView: ElementRef<HTMLElement>;

  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;
  @ViewChild(EkycCameraComponent, { static: false }) private ekyc;


  @BlockUI() blockUI: NgBlockUI;

  DEFAULT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document/';
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-receive/';
  SIGN_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-sign';
  APPOVAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-approval-waiting-document';
  INITIAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-initial-waiting-document';
  MY_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-my-created-document';
  WAIT_CONFIRM_ROUTER_ON_BACK_LINK = '/home-enterprise/search-waiting-confirm-document';

  // define buttons Mobile:
  slidesButtons: any[] = [];

  thumbnail = [];
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  beforeUpload = this.commonService.beforeUploadImage;
  isVisible = false;
  dateNow = format(new Date(), 'DD/MM/YYYY');
  isHasPermissionAddCert = false;
  pageCurrent = 1;

  allowOtp = false;
  allowImage = false;
  isPersonalCustomer = false;
  checkCertNumber = false;
  checkName = false;
  checkOtp = false;
  supportEkyc = false;
  isShowEKYC = false;
  enterpriseInfo: any;
  ekycSupportConfig: number = null;
  isStillQuantityEkyc = false;
  certificateTypeID = CertificateTypeID;
  isQuantityEkyc = false;
  isQuantityAdvancedEkyc = false;
  isCertificateSupport = false;
  isReloadCamera = true;
  isEmploymentContract: boolean = false;

  isSignEkyc = false;
  isSignAdvancedEkyc = false;
  isPassport = false;
  quantityEkyc: number;
  quantityAdvancedEkyc: number;
  userCancel = false
  validateSignNextStep = {
    certificateNo: '',
    representDocumentNumber: '',
    taxCode: '',
    enterpriseName: ''
  };

  signPositionTypes = SignPositionTypes;
  onlyDigital = false;

  isVisibleMiddle = false;

  fileSrc: any[] = [];
  activeFile: number = 0;
  fileError: string[] = [];
  signPositionCache: any[] = [];
  signProcessing: any[] = [];
  signError: string = null;
  isCancel: boolean = false;
  isCallDone: boolean = false;
  processingId: string = null;
  roleApprover: any;
  isSignDigitalCertificate = false;
  imagePreviewWidth: number;
  private imagePreviewHeight: number;

  async onSelectSignMethod() {
    // check simCA hoặc Usb token
    if ((this.selectedCert.typeCertificate === CertificateType.USB_TOKEN
      || this.selectedCert.typeCertificate === CertificateType.SIM_CA
      || this.selectedCert.typeCertificate === CertificateType.CLOUD_CA) && this.roleApprover != '2') {
      if (this.checkCertNumber) {
        if(this.isEmploymentContract){
        if (this.selectedCert.taxCode.length > 0
          && (this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.certificateNo.toUpperCase() ||
            (this.validateSignNextStep.representDocumentNumber && this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.representDocumentNumber.toUpperCase()) ||
            (this.validateSignNextStep.taxCode && this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.taxCode.toUpperCase()))) {
        } else {
          this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
          return false;
        }
      }
      }

      // check name
      if (this.checkName) {
        let enterpriseName = localStorage.getItem('enterpriseNameProcessing');
        enterpriseName = this.validateSignNextStep.enterpriseName;
        if (enterpriseName && this.selectedCert.issuedTo && (this.selectedCert.issuedTo.toUpperCase() !== enterpriseName.toUpperCase())) {
          this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
          return false;
        }
      }
    }

    if (this.selectedCert.typeCertificate === this.signMethod.SIGN_USB_TOKEN) {
      // check connect plugins
      this.blockUI.start('');
      await checkPlugin(this);
    }

    this.openConfirmDialog()
  }

  openConfirmDialog() {
    let signMethod = '';
    switch (this.selectedCert.typeCertificate) {
      case 1:
        signMethod = this.translateService.instant('digital_certificate_management.rd_certificate_type.cbx_usb');
        break;
      case 2:
        signMethod = this.translateService.instant('digital_certificate_management.rd_certificate_type.cbx_sim_ca');
        break;
      case this.enumSignMethod.CLOUD_CA:
        signMethod = this.translateService.instant('digital_certificate_management.cbx_certificate_type.cbx_cloud_ca');
        break;
    }

    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: `
        <p>${this.commonService.format(this.message.getMessage('sign_confirm.message_confirm'), `${this.document.code} - ${this.document.name}`, signMethod)}</p>
        <br/>
        <p>${this.message.getMessage('sign_confirm.message_confirm_info_1')}: <strong>${this.selectedCert.issuedTo}</strong></p>
        <p>${this.message.getMessage('sign_confirm.message_confirm_info_2')}: <strong>${this.selectedCert.serialNumber}</strong></p>
        <p>${this.message.getMessage('sign_confirm.message_confirm_info_3')}: <strong>${this.selectedCert.taxCode}</strong></p>
      `
    });
    dialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.selectMethodDialogRef.close();
        this.checkTimestampMoney();
      }
    })
  }

  handlePreviewFromFileUpload(fileUpload: File) {
    this.commonService.getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        this.selectedImageUrl = imageUrlPreviewBlod;
      });
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onNoClick();
  }

  onNoClick() {
    this.selectMethodDialogRef.close();
    this.subscriptions.unsubscribe();
  }

  async ngOnInit() {
    this.contractId = this.data.contractId;
    this.subscribeValue();
    this.getEnterprise();
    const userId = localStorage.getItem('userId');
    if (userId) {
      this.documentService.getListEnterpriseUserSignBydocumentIdService(this.contractId).subscribe(res => {
        this.roleApprover = 6;
        this.isSignDigitalCertificate = true;
        this.loadConfigAndCertificates(this.roleApprover);
      });
    } else {
      this.loadConfigAndCertificates('');
    }

    // kiểm tra xem có quyền quản lý tt doanh nghiệp hay không
    if (this.permissions.includes(1)) {
      this.isHasPermissionAddCert = true;
    }

  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumnsSimCA();
          this.getDisplayedColumnsOther();
          this.getDisplayedColumnsCloudCa();
        }
      }
    );

    this.subcribeViewLandscape = this.responsiveService.getView().subscribe(isLandscape => {
      this.isViewLandscape = isLandscape;
    });
    this.getDocumentById();
  }

  getDisplayedColumnsSimCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.map(cd => cd.def);
        break;
    }
  }

  getDisplayedColumnsOther() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplayOther = this.columnDefinitionsOther.map(cd => cd.def);
        break;
    }
  }

  getDisplayedColumnsCloudCa() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.map(cd => cd.def);
        break;
    }
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subcribeViewLandscape.unsubscribe();
  }

  subscribeValue() {
    this.documentService.contractInfo.subscribe(contract => {
      if (!contract) {
        this.getDocumentById();
      } else {
        this.document = contract;
      }
    });

    this.documentService.contractFilesInfo.subscribe(info => {
      this.listPdfSrc = info;
    });
    this.notificationService.subscribeErrorService();

    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.isCheckAccessToContract = false;
      } else {
        this.isCheckAccessToContract = true;
      }

      if (errorCode === ErrorCode.NotPermissionWithContract) {
        this.backToPrePage();
      }
    });

    this.processRouteAndBreadcrumbs();
    // lấy sign position
    this.documentService.getSignPosition().subscribe(position => {
      if (this.signPosition && this.signPosition.length > 0) {
        this.isConfiguredSign = true
        this.checkSignManual();
      } else {
        this.isAllowSelectSignPosition = true;
      }
    });

    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.isCancelSign = status
      }
    })
  }

  getDocumentById() {
    if (this.data.contractId) {
      this.documentService.getDocumentById(this.data.contractId).subscribe(rs => {
        if (!rs || !rs.data) {
          if (rs && rs.message) {
            this.toastr.error(rs.message);
          }
          return;
        }
        this.document = rs.data.contractDTO;
        this.documentService.setContractInfo(rs.data.contractDTO);
        this.signPosition = rs.data.approveContractSigns;
        this.documentService.setSignPosition(this.signPosition);
        if (this.signPosition && this.signPosition.length > 0) {
          this.isConfiguredSign = true
          this.imageData = rs.data.approveContractSigns.map((item) => {
            const image = {
              positionX: item.x,
              positionY: item.y,
              pageNumber: item.pageNumber,
              signType: item.signType,
              widthRectangle: item.width,
              heightRectangle: item.height,
              zoom: 1,
              fileId: item.fileId,
              signPositionId: item.id,
              contractSignId: item.id,
              signerName: item.signerName,
              metadata: item.metadata,
            };

            return image;
          });
        } else {
          this.isAllowSelectSignPosition = true;
          this.signPosition = []
        }
      });
    }
  }

  openDialogAddCert() {
    this.dialogRef = this.dialog.open(AddDigitalCertificateComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '80%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (this.dialogRef.componentInstance.success) {
        this.getCertificatesPreOne();
        this.selectFirstCertificate();
      }
    });
  }

  getCertificates() {
    //     this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      this.imageCertificates = [];
      this.certificates = rs.data;
      this.isCertificateDefault = false;
      let indexCer = 0;
      let countList = -1;
      let indexList = 0;
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          countList++;
          cerType.listCert = cerType.listCert.map((item, index) => {
            if (item.defaultCertificate && !(item.typeCertificate === 0 && !this.isHsmPermission)) {
              this.isCertificateDefault = true;
              indexCer = index;
              indexList = countList;
            }
            const { imagePath } = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl
              };
            } else {
              return {
                ...item,
                imageUrl: ''
              };
            }
          });
        }
        this.imageCertificates = [
          ...this.imageCertificates,
          ...this.certificates.filter(certificate => [1, 2, this.enumSignMethod.CLOUD_CA].includes(certificate.type)),
        ];
      }

      if (this.imageCertificates.length > 0) {
        // Select first certificate
        this.typeCertificate = this.imageCertificates[0].type;
        if (this.isCertificateDefault) {
          this.selectedCert = this.imageCertificates[indexList].listCert[indexCer];
        } else {
          this.selectedCert = this.imageCertificates[0].listCert[0];
        }

        this.isCheckedFirstCertificate();
        this.isDisableNextButton = false;
      } else {
        this.isDisableNextButton = true;
      }
      this.selectedIndex = 0;
      if (this.isCertificateDefault) {
        // this.countAllApiBeforeCertificateDefault += 1;
        this.sertificateDefaultOnj = this.imageCertificates[indexList].listCert[indexCer];
        this.signFlowDocumentWithCerDefault();
      }
    });
  }

  private isCheckedFirstCertificate() {
    if ((this.selectedCert.typeCertificate == this.signMethod.SIGN_OTP || this.selectedCert.typeCertificate == this.signMethod.SIGN_NO_CERT)
      && (this.isStillQuantityEkyc && this.supportEkyc && !this.isCertificateSupport) || (!this.isStillQuantityEkyc && this.supportEkyc)) {
      this.selectedCert = {
        serialNumber: '',
        phoneNumber: undefined,
        typeCertificate: undefined,
        id: undefined,
        idDetail: undefined,
        imageUrl: null,
        issuedTo: '',
        taxCode: '',
      };
      this.isReloadCamera = true;
    } else if (this.selectedCert.typeCertificate == this.signMethod.SIGN_OTP || this.selectedCert.typeCertificate == this.signMethod.SIGN_NO_CERT) {
      this.isReloadCamera = false;
    }
  }

  async selectFirstCertificate() {
    this.blockUI.start('');
    // await this.getCertificates().toPromise().then();
    this.getEnterprise();
    this.blockUI.stop();
    if (this.imageCertificates.length > 0) {
      let isSelectCertificate = false;
      // if (this.supportEkyc) {
      this.imageCertificates.forEach((certificate, index) => {
        if (isSelectCertificate) return;
        if (certificate.type === this.signMethod.SIGN_NO_CERT
          || certificate.type === this.signMethod.SIGN_OTP) {
          if (this.supportEkyc) {
            if (this.isStillQuantityEkyc) {
              if (this.isCertificateSupport) {
                this.typeCertificate = this.imageCertificates[index].type;
                this.selectedCert = this.imageCertificates[index].listCert[0];
                isSelectCertificate = true;
              }
            }
          } else {
            this.typeCertificate = this.imageCertificates[index].type;
            this.selectedCert = this.imageCertificates[index].listCert[0];
            isSelectCertificate = true;
          }
        } else {
          setTimeout(() => {
            this.typeCertificate = this.imageCertificates[index].type;
            this.selectedCert = this.imageCertificates[index].listCert[0];
          }, 0);
          isSelectCertificate = true;
        }
      })
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  async processSignSimCAImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    this.signDocumentService.signSimCAWithImageBase64(sign).then(res => { })
    this.signingProcess(sign.signTransactionCode)
  }

  async processSignCloudCA() {
    const filePath = {};
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = []
    for (const item of this.signProcessing) {
      item.index = id;
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item
        })
      } else {
        hashMap[fileId] = [{
          ...item
        }]
      }
      id++;
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign
      })
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length
      }
    }
    // // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < this.signProcessing.length; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
            signProcessingId: position.index
          };
          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === dataItem.fileId);
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId] ? filePath[requestItem.fileId] : '';
          signPositions.push(requestItem);
        }
      }
    }
    const newRequest = {
      ...this.sign,
      listSignPosition: signPositions,
      signTransactionCode: this.commonService.generateUUID(),
      signApprove: true
    };
    this.signDocumentService.signCloudCANoImage(newRequest).subscribe(res => { 
      if (res.success) {
        this.showPopupSaveTrans = res.data.showPopupSaveTrans;
      }
    })
    this.signingProcess(newRequest.signTransactionCode)
  }

  async processSignSimCANoImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signApprove = true;
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = this.signProcessing
    this.signDocumentService.signSimCANoImage(sign).subscribe(res => { })
    this.signingProcess(sign.signTransactionCode)
  }

  onClickConfirmButton() {
    setTimeout(() => {
      switch (this.selectedCert.typeCertificate) {
        case this.signMethod.SIGN_USB_TOKEN:
          this.isCallDone = true;
          initPluginCertificateNormal(this, null);
          break;
        case this.signMethod.SIGN_SIM_CA:
          this.processSignSimCANoImage();
          break;
        case EnumSignMethod.CLOUD_CA:
          this.isCallDone = false;
          this.processSignCloudCA();
          break;
        default:
          break;
      }
    }, 400);
  }

  onClickConfirmButtonImage() {
    setTimeout(() => {
      switch (this.selectedCert.typeCertificate) {
        case this.signMethod.SIGN_USB_TOKEN:
          this.isCallDone = true;
          initPluginCertificateNormal(this, null);
          break;
        case this.signMethod.SIGN_SIM_CA:
          this.processSignSimCAImage();
          break;
        case EnumSignMethod.CLOUD_CA:
          this.isCallDone = false;
          this.processSignCloudCA();
          break;
        default:
          break;
      }
    }, 400);
  }

  private onSignSuccess() {
    this.dialog.closeAll();
    this.toastr.success(this.message.getMessage('messages.approve_sign_success'));
    this.blockUI.stop();
    if (this.showPopupSaveTrans == true) {
      const param = {
        digitalCertificateId: this.selectedCert.id,
        digitalCertificateDetailId: this.selectedCert.idDetail,
      };
      this.digitalCertificateService
        .getDurationCloudCa(param)
        .subscribe((res) => {
          console.log(res);
          let duration = -1;
          if (res.success) {
            duration = res.data.duration;
          } else {
            this.toastr.error(res.message);
          }
          const dialogRef = this.dialog.open(
            SaveSessionCloudCaDialogComponent,
            {
              width: "600px",
              disableClose: true,
              data: {
                duration: duration,
                name: this.selectedCert.issuedTo,
              },
            }
          );
          dialogRef.afterClosed().subscribe((rs) => {
            if (rs) {
              this.digitalCertificateService
                .saveSessionCloudCa({ ...param, duration: duration })
                .subscribe((res1) => {
                  console.log(res1);
                  if (res1.success) {
                    this.toastr.success(
                      this.message.getMessage(
                        "digital_certificate_management.save_session_cloudca_success"
                      )
                    );
                  } else {
                    this.toastr.error(res1.message);
                  }
                });
            }
            this.success = true;
            this.backToPrePage();
          });
        });
    } else {
      this.success = true;
      this.backToPrePage();
    }
  }

  backToPrePage() {
    this.router.navigate([this.routeLink], {});
  }

  handleDataTable() {
    const dataTable = [];

    this.signProcessing.sort(( a, b ) => {
      if (a.fileId < b.fileId) return -1;
      if (a.fileId > b.fileId) return 1;
      return 0;
    }).forEach((sign, i) => {
      if (dataTable.find(x => x.fileId === sign.fileId && x.rowspan > 0)) {
        dataTable.push({
          ...sign,
          rowspan: 0
        })
      } else {
        dataTable.push({
          ...sign,
          rowspan: this.signProcessing.filter(x => x.fileId === sign.fileId).length
        })
      }
    })
    console.log('dataTable', dataTable);
    this.signProcessing = dataTable;
  }

  async onClickSignButton() {
    if (this.document.isConfirmBCT) {
      this.signImages = this.signImages.map((item) => {
        item['signTransactionId'] = this.signTransactionId;
        return item;
      })
    }
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    setTimeout(() => {
      this.handleDataTable();
      this.dialogRef = this.dialog.open(SigningConfirmDialogComponent, {
        width: '80%',
        disableClose: true,
        data: this
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.signProcessing = [];
        this.errorStatus = null;
        this.signError = null;
        this.isCancel = false;
        this.isCallDone = false;
        this.processingId = null;
        // this.dialog.closeAll();
      });
    }, 0)

    if (this.fileUpload) {
      this.sign = {
        ...this.sign,
        image: this.fileUpload,
      };
    }

    this.onClickConfirmButton();
  }

  onSelectImageSignMethod(type: number) {
    if (this.isCertificateSupport && this.supportEkyc) {
      this.isReloadCamera = false;
    }
  }

  onChangeSubType(cert: any) {
    if ((cert.typeCertificate === this.signMethod.SIGN_OTP || cert.typeCertificate === this.signMethod.SIGN_NO_CERT) && this.isCertificateSupport && this.supportEkyc) {
      this.isReloadCamera = false;
    } else {
      this.isReloadCamera = true;
    }
  }

  onClickBtnCancel() {
    this.backToPrePage();
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }


  showErrMsgTransleFormat(msg) {
    const link = this.linkDownSignPlugin();

    this.dialog.open(AlertComponent, {
      width: '370px',
      data: this.message.getMessage(msg)
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
      // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
      //     + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
    });
  }

  showErrMsgTransle(msg) {
    if (msg === 'messages.not_initPlugin') {
      const link = this.linkDownSignPlugin();
      // if(msg === "messages.not_initPlugin"){
      msg = "messages.initPlugin_faile"
      // }

      this.signError = this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS');
      //sign cancel
      this.isCancel = true;
      this.documentService.setCancelFlow(true);
      const data = {
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        signMethod: this.selectedCert.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: [],
        certificate: this.sign.certificate,
        digitalCertificateDetailId: this.selectedCert.idDetail
      };
      this.errorStatus = "messages.stop_sign_confirm_document";
      this.userCancel = false
      this.signDocumentService.signCancel(data).subscribe(res => {});
    } else {
      // this.blockUI.stop();
      this.errorStatus = msg;
    }
  }

  showErrorDialog(msg) {
    // this.blockUI.stop();
    this.toastr.error(this.message.getMessage(msg));
  }

  showErrMsg(msg) {
    this.toastr.error(msg);
  }

  setSerialNumber(value) {
    this.sign.serialNumber = value;
  }

  setIssuedTo(value) {
    this.sign.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.sign.distinguishedName = value;
  }

  setTaxCode(value) {
    this.sign.taxCode = value;
  }

  setIssuedBy(value) {
    this.sign.issuedBy = value;
  }

  setCertRawdata(value) {
    this.sign.certRawdata = value;
  }

  setActiveDate(value) {
    this.sign.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.sign.expireDate = new Date(value);
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  async signFlowDocumentWithCerDefault() {
    // if (this.countAllApiBeforeCertificateDefault > 1 && this.sertificateDefaultOnj !== null && this.sertificateDefaultOnj !== undefined) {\
    if (this.sertificateDefaultOnj !== null && this.sertificateDefaultOnj !== undefined) {
      if (this.sertificateDefaultOnj.imageUrl !== '') {
        fetch(this.sertificateDefaultOnj.imageUrl)
          .then(r => r.blob())
          .then(blobFile => {
            this.fileUpload = new File([blobFile], 'fileNameGoesHere', { type: 'image/png' });
            if (this.fileUpload) {
              this.handlePreviewFromFileUpload(this.fileUpload);
            }
          });
      }
      if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_USB_TOKEN) {
        // check connect plugins
        this.blockUI.start('');
        await checkPlugin(this);
        this.current = 2;
        this.isVisible = true;
        if (this.isAllowSelectSignPosition) {
        }
      }
      else if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_NO_CERT && this.allowImage) {
        this.current = 0;
      } else {
        if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_OTP
          && this.supportEkyc && this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL) {
          this.isShowEKYC = true;
          this.validateData();
        }

        this.current = 2;
        if (this.document && this.document.mainContractAttachments) {
          setTimeout(() => {
            const tabs = document.getElementsByClassName('tab');
            if (tabs) {
              Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
                const tab = tabs.item(index) as HTMLElement;
                tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
              })
            }
          }, 100);
        }
        this.isVisible = true;
      }
    }
  }

  validateData() {
    if (this.selectedCert.typeCertificate === 3) {
      if (this.checkOtp) {
        const enterprisePhone = this.digitalCertificateService.formatPhoneNumber(localStorage.getItem('enterprisePhoneProcessing'));
        if (enterprisePhone && (this.selectedCert.phoneNumber !== enterprisePhone)) {
          const message = this.commonService.format(this.message.getMessage('messages.digital_certificate_validate_phone'), enterprisePhone);
          const dialogRe = this.dialog.open(AlertComponent, {
            width: '350px',
            data: message,
          });
          dialogRe.afterClosed().subscribe((rs) => {
            if (rs) {
              this.dialogRef.close();
            }
          });
          this.disableSignBtn = false;
          return;
        }
      }
    }

    //Check Loại giấy tờ
    if (this.isShowEKYC && this.isStillQuantityEkyc && this.supportEkyc && !this.isCertificateSupport) {
      // thông báo lỗi 'digital_certificate_management.certificate_not_support'
      const dialogRe = this.dialog.open(AlertComponent, {
        width: '350px',
        data: this.message.getMessage('digital_certificate_management.certificate_not_support'),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.disableSignBtn = false;
      return;
    }

    if (this.isShowEKYC && !this.isStillQuantityEkyc && this.supportEkyc) {
      const dialogRe = this.dialog.open(AlertComponent, {
        width: '350px',
        data: this.message.getMessage('digital_certificate_management.quantity_ekyc_not_enough'),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.disableSignBtn = false;
      return;
    }

    if (this.isShowEKYC && this.supportEkyc) {
      return;
    }

  }

  getCertificatesPreOne() {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      this.certificates = rs.data;
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          cerType.listCert = cerType.listCert.map((item) => {
            const { imagePath } = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl
              };
            } else {
              return {
                ...item,
                imageUrl: ''
              };
            }
          });
        }
        this.imageCertificates = [
          ...this.certificates
        ];
      }
      if (this.imageCertificates.length > 0) {
        this.typeCertificate = this.imageCertificates[0].type;
        this.selectedCert = this.imageCertificates[0].listCert[0];
        this.isCheckedFirstCertificate();
        this.isDisableNextButton = false;
      } else {
        this.isDisableNextButton = true;
      }
      this.selectedIndex = 0;
    });
  }

  loadConfigAndCertificates(role) {
    this.digitalCertificateService.getServiceTypeByContractId(this.contractId, role).subscribe(async (res) => {
      if (res.data) {
        // type = 2 là khách hàng cá nhân mới check
        // if (parseInt(localStorage.getItem('typeAllowCheck')) === 2) {
        res.data.allowImage ? this.allowImage = res.data.allowImage : this.allowImage = false;
        res.data.allowOtp ? this.allowOtp = res.data.allowOtp : this.allowOtp = false;
        // có vấn đề ở đống này

        this.supportEkyc = !!Number(res.data.ekycSupportConfig);
        this.ekycSupportConfig = res.data.ekycSupportConfig;
        if (this.supportEkyc) {
          await this.getQuantityEkyc();
        } else {
          // this.selectFirstCertificate();
        }
        // res.data.checkEkycSupport ? this.supportEkyc = res.data.checkEkycSupport : this.supportEkyc = false;
        // } else {
        //   this.allowImage = false;
        //   this.allowOtp = false;
        // }
        this.checkCertNumber = res.data.checkCertNumber;
        this.isEmploymentContract = res.data.isEmploymentContract;
        this.checkOtp = res.data.checkOtp;
        this.checkName = res.data.checkName;
        // this.countAllApiBeforeCertificateDefault += 1;
        // this.signFlowDocumentWithCerDefault();
        this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
          if(res && res.success){
            this.isHsmPermission = res.data.enableHsm;
            this.getCertificates();
          }
        })
      } else {
        this.toastr.error(this.message.getMessage('messages.error_data_wrong_digital_certificate'));
      }
    }, error => {
      this.toastr.error(this.message.getMessage('messages.error_data_wrong_digital_certificate'));
    });
  }

  blobToBinary(blob: Blob) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    })
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  checkSignManual() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter(sign => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0 ) {
      this.isAllowSelectSignPosition = false;
      this.isSelectPosition = false;
      if (signs.length === 1 && signs[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      // siten comment do code signType luôn khác COMBINE
      // if (signs.length === 1 && signs[0].signType === this.signPositionTypes.COMBINE) {
      //   this.isAllowSelectSignPosition = true;
      // }
    } else {
      this.isAllowSelectSignPosition = true;
    }
  }

  signCancel() {
    this.userCancel = true
    this.imageData = this.contractSignEntityList;
    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: this.message.getMessage('sign_processing_dialog.message_stop_sign')
    });
    dialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.isCancel = true;
        this.documentService.setCancelFlow(true);
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: [],
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail
        };
        this.errorStatus = "messages.stop_sign_confirm_document";
        this.userCancel = false
        this.signDocumentService.signCancel(data).subscribe(res => {
          // this.userCancel = false
          // this.errorStatus = "messages.stop_sign_confirm_document";
        });
        // this.blockUI.start();
      }
    })
  }

  // EKYC
  getEnterprise() {
    this.enterpriseService.getDetailCusByEnterprise(this.contractId).subscribe(res => {
      if (res && res.data) {
        this.enterpriseInfo = res.data;
        if (+res.data.certificateId === CertificateTypeID.HO_CHIEU) {
          this.isPassport = true;
        } else if (+res.data.certificateId === CertificateTypeID.CCCD || +res.data.certificateId === CertificateTypeID.CMTND) {
          this.isPassport = false;
        }

        if (+this.enterpriseInfo.certificateId === CertificateTypeID.CCCD
          || +this.enterpriseInfo.certificateId === CertificateTypeID.CMTND
          || +this.enterpriseInfo.certificateId === CertificateTypeID.HO_CHIEU) {
          this.isCertificateSupport = true;
        }
      }
    })
  }

  async getQuantityEkyc() {
    if (!this.contractId) return of(null);
    const res = await this.signDocumentService.getQuantityEkyc(this.contractId).toPromise()
    if (res.success === true && res.data) {
      if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) this.isStillQuantityEkyc = true; //normal
      if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) this.isStillQuantityEkyc = true; //Advance
      if (res.data.quantityEkyc) this.isQuantityEkyc = true;
      if (res.data.quantityAdvancedEkyc) this.isQuantityAdvancedEkyc = true;
    } else {
      this.toastr.error(this.message.getMessage(res.message));
    }
  }

  openDialogOutOfMoneyOtp(message) {
    const confirmDialog = this.dialog.open(NotifyWarningComponent, {
      data: message
    });
  }

  checkTimestampMoney() {

    this.isClickSignBuuton = true;

    // kiem tra file da ky day du chua
    if (this.document.mainContractAttachments && this.document.mainContractAttachments.length) {

      const fileName = [];
      let indexError = null;
      let filePathError = null;
      const fileError = [];
      this.document.mainContractAttachments.forEach((ca, index) => {
        const fileId = this.decodeId(ca.id);
        const sign = this.signPosition.filter(sign => {
          return sign.fileId === fileId;
        });
        if (!sign.length) {
          if (!indexError) {
            indexError = index;
            filePathError = ca.path
          }
          fileError.push(ca.id);
          fileName.push(`'${ca.fileName}'`);
        }
      });

      if(this.document.status === EnumContractStatus.CANCELLED){
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.cancel_sign_flow_with_contract'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        return;
      }

      if (fileName.length) {
        this.changeFile(filePathError, indexError);
        this.fileError = fileError;
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        return;
      }
    }
    if (this.saveImageData.length == 0) {
      this.saveImageData = _.cloneDeep(this.imageData);
    } else
      this.imageData = this.saveImageData;

    this.sign = {
      contractId: this.contractId,
      digitalCertificateId: this.selectedCert.id,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      ...this.selectedCert
    };
    let preImageSort = [];

    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      const imageData = this.imageData.filter(item => {
        return item.fileId === fileId
      });
      preImageSort = preImageSort.concat(imageData);
    }
    const imageSort = _.cloneDeep(preImageSort);
    let imageData = []
    const arr1 = [];
    for (let i = 0; i < imageSort.length; i++) {
      for (let j = 0; j < imageSort.length; j++) {
        if (i !== j && imageSort[j].positionX == imageSort[i].positionX
          && imageSort[j].positionY == imageSort[i].positionY
          && imageSort[j].pageNumber == imageSort[i].pageNumber
          && imageSort[j].widthRectangle == imageSort[i].widthRectangle
          && imageSort[j].heightRectangle == imageSort[i].heightRectangle
          && imageSort[j].zoom == imageSort[i].zoom
          && imageSort[j].fileId == imageSort[i].fileId
          && imageSort[j].signType !== imageSort[i].signType) {
          if (imageSort[j].signType == 'image') {
            arr1.push(imageSort[j])
          } else {
            arr1.push(imageSort[i])
          }
          imageSort.splice(j, 1);
          imageSort.splice(i, 1);
          i--;
          break;
        }
      }
    }
    imageData = ([...imageSort, ...arr1]);
    let imagePreSort = [];
    const mapFiles = FileUtils.getCodeOfFileWhenSignOnce(this.document.mainContractAttachments);
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      let imageList = imageData.filter(item => {
        return item.fileId === fileId
      });
      imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
        Number(b.positionY) - Number(a.positionY) :
        Number(a.pageNumber) - Number(b.pageNumber));
      imagePreSort = imagePreSort.concat(imageList);
    }
    this.signImages = imagePreSort.map((item) => {
      item['code'] = mapFiles.get(item.fileId);
      return item;
    });
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    if (this.document.isConfirmBCT && this.selectedCert.typeCertificate !== this.signMethod.SIGN_USB_TOKEN) {
      let body = {};
      if (this.roleApprover == '2') {
        this.signImages.forEach(rs => {
          rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
        });
        body = {
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.contractId,
          signPositions: this.signImages
        };
      } else {
        body = {
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.contractId,
          signPositions: this.signImages
        };
      }
      this.documentService.createTimestampMoney(body).subscribe(
        res => {
          this.blockUI.stop();
          if (res && !res.success) {
            if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
              this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
            else
              this.toastr.error(res.message)
          } else {
            this.signTransactionId = res.data;
            this.onClickSignButton()
          }
        }
      )
    } else {
      this.blockUI.reset();
      this.blockUI.start('');
      if (this.document.isConfirmBCT) {
        let body = {};
        if (this.roleApprover == '2') {
          this.signImages.forEach(rs => {
            rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
          });
          body = {
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.contractId,
            signPositions: this.signImages
          };
        } else {
          body = {
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.contractId,
            signPositions: this.signImages
          };
        }
        this.documentService.createTimestampMoney(body).subscribe(
          res => {
            this.blockUI.stop();
            if (res && !res.success) {
              if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
              else
                this.toastr.error(res.message)
            } else {
              this.signTransactionId = res.data;
              this.onClickSignButton()
            }
          }
        )
      } else {
        this.signImages = imagePreSort;
        this.blockUI.stop();
        this.onClickSignButton();
      }
    }
  }
  // Hàm xử lý lấy kết quả phiên ký liên tục mỗi 2s
  signingProcess(signTransactionCode, dialog?: any, focusInput?: any) {
    setTimeout(() => {
      this.signingInteval = setInterval(() => {
        this.signDocumentService.getStatusSign({
          signTransactionCode: signTransactionCode,
          signApprove: true
        }).subscribe(rs => {
          if (rs && rs.success && (rs.data.status == 'DONE' || rs.data.status == 'DAEMON_PROCESSING')) {
            this.isCallDone = true;
            this.signDocumentService.openSigningDialog.next(false);
            clearInterval(this.signingInteval);
            this.onSignSuccess();
          } else if (rs && rs.success && rs.data.status !== 'ERROR') {
            let arrayStatus = {};
            for (let i = 0; i < rs.data.list.length; i++) {
              arrayStatus[rs.data.list[i].code] = rs.data.list[i].status;
            }
            for (let i = 0; i < this.signProcessing.length; i++) {
              this.signProcessing[i].done = arrayStatus[this.signProcessing[i].code] == 'DONE' || arrayStatus[this.signProcessing[i].code] == 'DAEMON_PROCESSING' ? true : false
            }
          } else if (rs.data && rs.data.status === 'ERROR') {
            this.signDocumentService.openSigningDialog.next(false);
            this.errorStatus = "messages.stop_sign_confirm_document";
            this.signError = rs && rs.data.message ? rs.data.message : null;
            clearInterval(this.signingInteval);
          }
        })
      }, 1000)
    }, 1000);
  }

  changeFile(filePath: string, index: number) {
    this.isSelectPosition = false;
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.pageCurrent = 1;
    this.activeFile = index;
    this.checkSignManual();
    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }

  getSignImageBlob(imagePath: string) {
    return new Promise((resolve, reject) => {
      this.documentService.getSignImage({
        contractId: this.data.contractId,
        signImagePath: imagePath
      }).subscribe(async res => {
        resolve(res);
      });
    })
  }

  async createHash(certUserBase64: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;

      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      const fileArr = new Set(this.data.signImages.map($ => $.fileId))
      // debugger
      for await (let [idx, fileId] of fileArr.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }

        let rs;
        const sign = JSON.parse(JSON.stringify(this.sign));
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[''+fileId] ? filePath[''+fileId] : '';
        sign.signApprove = true;
        const _dst$ = this.data.signImages.filter($ => $.fileId == fileId);

        const signContent = JSON.parse(_dst$[0].metadata);

        if (signContent.pathImage) {
          sign.image = _dst$[0].blob;
          if (!_dst$[0].blob) sign.image = await this.getSignImageBlob(signContent.pathImage);
          sign.position = JSON.stringify(_dst$[0]);
          sign.signPositions = _dst$;
          rs = await this.documentService.createHashWithImageBase64(sign);
        } else {
          sign.position = _dst$[0];
          rs = await this.documentService.createHashNoImage(sign).toPromise();
        }

        if (rs && !rs.success) {
          isSuccess = false;
          this.signError = rs && rs.message ? rs.message : null;
          break;
        }

        if (rs && rs.data) {
          filePath[''+fileId] = rs.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = rs.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = rs.data.path;
          }
          delete sign.oldPath;
          sign.path = rs.data.path;
          sign.signPdf = rs.data.signPdf;
          const signature = await signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
          if (signature) {
            if (idx === 0) {
              this.isCallDone = false;
            }

            if (signContent.pathImage) {
              sign.position = JSON.parse(sign.position);
            } else {
              sign.signPositions = this.data.signImages;
            }
            const resSign = await this.signUsbNormal(signature, sign);
            if (resSign && !resSign.success) {
              isSuccess = false;
              this.signError = resSign && resSign.message ? resSign.message : null;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            _dst$.forEach($ => $.done = true);
          } else {
            isSuccess = false;
            break;
          }
        } else {
          isSuccess = false;
          break;
        }
      }

      if (this.isCancel) {
        isSuccess = false;
      }
      const data = {
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        signMethod: this.selectedCert.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        digitalCertificateDetailId: this.selectedCert.idDetail,
        signApprove: true
      }
      if (isSuccess) {
        this.isCallDone = true;
        this.signDocumentService.signDone(data).subscribe(res => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
          err => {
            this.errorStatus = this.message.getMessage('messages.sign_fail');
          })
      } else {
        this.errorStatus = "messages.stop_sign_confirm_document";
        this.signDocumentService.signCancel(data).subscribe(res => { });
      }
    }
  }

  async signUsbNormal(signature: string, sign: any) {
    sign.signature = signature;
    const res = await this.signUsb(sign);
    return res;
  }

  async signUsb(certificate: any) {
    const res = await this.documentService.signUsb(certificate).toPromise();
    return res;
  }

  processRouteAndBreadcrumbs(): void {
    this.activeRoute
      .queryParams
      .subscribe(params => {
        this.signPage = params.signPage || 1;
        this.page = params.page || 0;
        this.pageSize = params.pageSize || 0;
        this.enterprise = params.enterprise || null;
        this.documentTypeSearch = params.documentType || null;
        this.nameOrCode = params.nameOrCode || null;
        this.status = Common.DOCUMENT_STATUS.indexOf(params.status) === -1 ? null : params.status;
        this.serviceType = params.serviceType || null;
        this.taxCode = params.taxCode || null;
        this.createdUser = params.createdUser || null;
        this.createdTimeFrom = params.createdTimeFrom || null;
        this.createdTimeTo = params.createdTimeTo || null;
        this.finishDateFrom = params.finishDateFrom || null;
        this.finishDateTo = params.finishDateTo || null;
        this.sortColumn = params.sortColumn || null;
        this.sortDirection = params.sortDirection || null;
        this.goFrom = params.goFrom || null;
        this.customerName = params.customerName || '';

        this.documentService.getSignDataValidate().subscribe((validate: any) => {

          if(validate.hasOwnProperty("certificateNo")){
            this.validateSignNextStep.certificateNo = validate.certificateNo;
          }

          if(validate.hasOwnProperty("representDocumentNumber")){
            this.validateSignNextStep.representDocumentNumber = validate.representDocumentNumber;
          }

          if(validate.hasOwnProperty("taxCodeValidate")){
            this.validateSignNextStep.taxCode = validate.taxCodeValidate;
          }

          if(validate.hasOwnProperty("enterpriseName")){
            this.validateSignNextStep.enterpriseName = validate.enterpriseName;
          }

        });

        // tslint:disable-next-line:radix

        this.routeLink = this.WAIT_CONFIRM_ROUTER_ON_BACK_LINK;
      });
  }

  blobToSrc(blob: any) {
    return new Promise((resolve, reject) => {
      try {
        const file = this.blobToFile(blob, 'application/pdf');
        this.commonService.readFile(file, (pdfSrc) => {
          // if(!this.listPdfSrc){
          //   this.listPdfSrc = {}
          // }
          // this.listPdfSrc[pdfFilePath] = pdfSrc;
          // this.document.mainContractAttachments.forEach(item => {
          //   if (item.path == pdfFilePath) {
          //     item.loading = false;
          //   }
          // });
          resolve(pdfSrc)
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }
}
